import { router } from "@inertiajs/react";
import { RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui/button";

export function NewVersionAvailableBanner() {
  const { t } = useTranslation("common");
  const [reloadUrl, setReloadUrl] = useState<URL | null>(null);

  useEffect(() => {
    return router.on("location", (event) => {
      if (!event.detail.versionChange) {
        return;
      }

      event.preventDefault();
      setReloadUrl(event.detail.url);
    });
  }, []);

  if (!reloadUrl) {
    return null;
  }

  const updateNow = () => {
    if (reloadUrl.href === window.location.href) {
      window.location.reload();
      return;
    }

    window.location.href = reloadUrl.href;
  };

  return (
    <div className="pointer-events-none fixed right-4 top-4 z-[100] flex justify-end sm:right-6 sm:top-6">
      <div className="pointer-events-auto flex w-[min(360px,calc(100vw-2rem))] items-center gap-3 rounded-xl border border-border/80 bg-background/95 p-3 shadow-2xl shadow-black/15 backdrop-blur supports-[backdrop-filter]:bg-background/80 dark:shadow-black/40">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <RefreshCw className="size-4" aria-hidden="true" />
        </div>
        <p className="min-w-0 flex-1 text-sm font-semibold text-foreground">
          {t("newVersionAvailable.title", "A new version is available")}
        </p>
        <Button size="sm" onClick={updateNow} className="shrink-0">
          {t("newVersionAvailable.update", "Update")}
        </Button>
      </div>
    </div>
  );
}
